<ion-tabs #tabs (ionTabsDidChange)="setCurrentTab()">

  <ng-container *ngIf="tabType && showTab">
    <ng-container *ngIf="tabType === 'accounts' && showTab">
      <ion-tab-bar class="ion-no-border ion-hide-lg-up" color="white" slot="bottom">
        <ion-tab-button tab="list">
          <ion-icon color="black" name="home" *ngIf="selectedTab === 'list'"></ion-icon>
          <ion-icon color="black" name="home-outline" *ngIf="selectedTab !== 'list'"></ion-icon>
          <ion-label>{{ 'MENU.home' | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button (click)="presentAccountsAddModal()">
          <ion-icon color="black" name="add-circle" *ngIf="selectedTab === 'new'"></ion-icon>
          <ion-icon color="black" name="add-circle-outline" *ngIf="selectedTab !== 'new'"></ion-icon>
          <ion-label>{{ 'CRUD.add' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="inbox">
          <div>
            <ion-icon color="black" name="chatbubble-ellipses" *ngIf="selectedTab === 'inbox'"></ion-icon>
            <ion-icon color="black" name="chatbubble-ellipses-outline" *ngIf="selectedTab !== 'inbox'"></ion-icon>
            <!-- <app-inbox-count class="badge" [badgeColor]="'danger'" [showBadge]="true" [showNumber]="true"></app-inbox-count> -->
            <app-inbox-count class="badge" [dotTop]="'0px'"></app-inbox-count>
          </div>

          <ion-label>{{ 'MENU.inbox' | translate }}</ion-label>
        </ion-tab-button>

        <!-- <ion-tab-button (click)="toggleAccountsListSearchMode()" *ngIf="selectedTab === 'list'">
          <ion-icon color="black" name="search" *ngIf="selectedTab === 'list' && accountsListSearchMode"></ion-icon>
          <ion-icon color="black" name="search-outline" *ngIf="selectedTab !== 'list' || !accountsListSearchMode"></ion-icon>
          <ion-label>{{ 'BTN.search' | translate }}</ion-label>
        </ion-tab-button> -->
        
        <ion-tab-button tab="profile">
          <ion-avatar class="small-avatar">
            <ng-container *ngIf="user?.avatar?.url">
              <ion-img [src]="user.avatar.url" *ngIf="user.avatar?.type === 'local'"></ion-img>
              <app-cached-image [src]="user.avatar.url" [spinner]="true" *ngIf="user?.avatar?.type !== 'local'"></app-cached-image>
            </ng-container>
            <ion-icon color="medium" src="./assets/wedding/img/avatar/blank.svg" *ngIf="!user?.avatar?.url"></ion-icon>        
          </ion-avatar>
        </ion-tab-button>
      </ion-tab-bar>
    </ng-container>

    <ng-container *ngIf="tabType === 'guest' && showTab">
      <ion-tab-bar class="ion-no-border" color="white" slot="bottom">
        <ion-tab-button tab="home">
          <ion-icon color="black" name="home" *ngIf="selectedTab === 'home'"></ion-icon>
          <ion-icon color="black" name="home-outline" *ngIf="selectedTab !== 'home'"></ion-icon>
          <ion-label>{{ 'MENU.home' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="list">
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest.svg" *ngIf="selectedTab === 'list'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest-outline.svg" *ngIf="selectedTab !== 'list'"></ion-icon>
          <ion-label>{{ 'GUEST.lbl.guests' | translate }}</ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="new" [disabled]="!currentPrivilege?.[tabType]?.['new']">
          <ion-icon color="black" name="add-circle" *ngIf="selectedTab === 'new'"></ion-icon>
          <ion-icon color="black" name="add-circle-outline" *ngIf="selectedTab !== 'new'"></ion-icon>
          <ion-label>{{ 'CRUD.new' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="qrcode" [disabled]="!currentPrivilege?.[tabType]?.['qrcode']">
          <ion-icon color="black" src="./assets/wedding/icon/tabs/qrcode.svg" *ngIf="selectedTab === 'qrcode'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/tabs/qrcode-outline.svg" *ngIf="selectedTab !== 'qrcode'"></ion-icon>
          <ion-label>{{ 'MODULE.list.qrcode' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="seating">
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating.svg" *ngIf="selectedTab === 'seating'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating-outline.svg" *ngIf="selectedTab !== 'seating'"></ion-icon>
          <ion-label>{{ 'MODULE.action.guest.seating' | translate }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ng-container>
  
    <ng-container *ngIf="tabType === 'checkin' && showTab">
      <ion-tab-bar class="ion-no-border" color="white" slot="bottom">
        <ion-tab-button tab="home">
          <ion-icon color="black" name="home" *ngIf="selectedTab === 'home'"></ion-icon>
          <ion-icon color="black" name="home-outline" *ngIf="selectedTab !== 'home'"></ion-icon>
          <ion-label>{{ 'MENU.home' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="list">
          <ion-icon color="black" name="search" *ngIf="selectedTab === 'list'"></ion-icon>
          <ion-icon color="black" name="search-outline" *ngIf="selectedTab !== 'list'"></ion-icon>
          <ion-label>{{ 'BTN.search' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="scan">
          <ion-icon color="black" src="./assets/wedding/icon/qrcode/scan-circle.svg" *ngIf="selectedTab === 'scan'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/qrcode/scan-circle-outline.svg" *ngIf="selectedTab !== 'scan'"></ion-icon>
          <ion-label>{{ 'BTN.scan' | translate }}</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="new" [disabled]="!currentPrivilege?.[tabType]?.['new']">
          <ion-icon color="black" name="add-circle" *ngIf="selectedTab === 'new'"></ion-icon>
          <ion-icon color="black" name="add-circle-outline" *ngIf="selectedTab !== 'new'"></ion-icon>
          <ion-label>{{ 'CRUD.new' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="seating">
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating.svg" *ngIf="selectedTab === 'seating'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating-outline.svg" *ngIf="selectedTab !== 'seating'"></ion-icon>
          <ion-label>{{ 'MODULE.action.guest.seating' | translate }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ng-container>
  
    <ng-container *ngIf="tabType === 'gift' && showTab">
      <ion-tab-bar class="ion-no-border" color="white" slot="bottom">
        <ion-tab-button tab="home">
          <ion-icon color="black" name="home" *ngIf="selectedTab === 'home'"></ion-icon>
          <ion-icon color="black" name="home-outline" *ngIf="selectedTab !== 'home'"></ion-icon>
          <ion-label>{{ 'MENU.home' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="list">
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift.svg" *ngIf="selectedTab === 'list'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift-outline.svg" *ngIf="selectedTab !== 'list'"></ion-icon>
          <ion-label>{{ 'GIFT.lbl.gift' | translate }}</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="new" [disabled]="!currentPrivilege?.['gift']?.['new']">
          <ion-icon color="black" name="add-circle" *ngIf="selectedTab === 'new'"></ion-icon>
          <ion-icon color="black" name="add-circle-outline" *ngIf="selectedTab !== 'new'"></ion-icon>
          <ion-label>{{ 'CRUD.new' | translate }}</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="guest">
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest.svg" *ngIf="selectedTab === 'guest'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest-outline.svg" *ngIf="selectedTab !== 'guest'"></ion-icon>
          <ion-label>{{ 'GUEST.lbl.guests' | translate }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="seating">
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating.svg" *ngIf="selectedTab === 'seating'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/guest/seating-outline.svg" *ngIf="selectedTab !== 'seating'"></ion-icon>
          <ion-label>{{ 'MODULE.action.guest.seating' | translate }}</ion-label>
        </ion-tab-button>
    
      </ion-tab-bar>
    </ng-container>
  
    <ng-container *ngIf="tabType === 'trash' && showTab">
      <ion-tab-bar class="ion-no-border" color="white" slot="bottom">  
        <ion-tab-button tab="guest">
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest.svg" *ngIf="selectedTab === 'guest'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/tabs/guest-outline.svg" *ngIf="selectedTab !== 'guest'"></ion-icon>
          <ion-label>{{ 'GUEST.lbl.guests' | translate }}</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="gift">
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift.svg" *ngIf="selectedTab === 'gift'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift-outline.svg" *ngIf="selectedTab !== 'gift'"></ion-icon>
          <ion-label>{{ 'GIFT.lbl.gift' | translate }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ng-container>

    <ng-container *ngIf="tabType === 'blast' && showTab">
      <ion-tab-bar class="ion-no-border" color="white" slot="bottom">  
        <ion-tab-button tab="home">
          <ion-icon color="black" name="home" *ngIf="selectedTab === 'home'"></ion-icon>
          <ion-icon color="black" name="home-outline" *ngIf="selectedTab !== 'home'"></ion-icon>
          <ion-label>{{ 'MENU.home' | translate }}</ion-label>
        </ion-tab-button>
  
        <ion-tab-button tab="package">
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift.svg" *ngIf="selectedTab === 'package'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift-outline.svg" *ngIf="selectedTab !== 'package'"></ion-icon>
          <ion-label>{{ 'BLAST.package.title' | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="credit">
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift.svg" *ngIf="selectedTab === 'credit'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift-outline.svg" *ngIf="selectedTab !== 'credit'"></ion-icon>
          <ion-label>{{ 'BLAST.credit.title' | translate }}</ion-label>
        </ion-tab-button>

        <!-- <ion-tab-button tab="send">
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift.svg" *ngIf="selectedTab === 'send'"></ion-icon>
          <ion-icon color="black" src="./assets/wedding/icon/gift/gift-outline.svg" *ngIf="selectedTab !== 'send'"></ion-icon>
          <ion-label>{{ 'BLAST.lbl.send' | translate }}</ion-label>
        </ion-tab-button> -->
      </ion-tab-bar>
    </ng-container>
  </ng-container>
  
</ion-tabs>
